import React from 'react';
import { PageBodyComponents } from '@utils/renderComponent';
import { createRoot } from 'react-dom/client';

declare global {
  interface Window {
    wpData: any;
    pageHeader: any;
    footerData: any;
    headerData: any;
  }
}
const rootElement = document.getElementById('react-components-container');
if (rootElement) {
  rootElement.style.opacity = '0';
  createRoot(rootElement).render(<PageBodyComponents />);;
  setTimeout(() => {
    rootElement.style.transition = 'opacity 0.3s ease-in-out';
    rootElement.style.opacity = '1';
  }, 50);
}

